import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderNextWeek: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalenderNextWeek"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19.5 8H4.5V19.5H19.5V8ZM8.5 10.6893L11.5607 13.75L8.5 16.8107L7.43934 15.75L9.43934 13.75L7.43934 11.75L8.5 10.6893ZM13.5 10.6893L16.5607 13.75L13.5 16.8107L12.4393 15.75L14.4393 13.75L12.4393 11.75L13.5 10.6893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderNextWeek;
